const sendNotifyEvent = (eventName, attributes, lifetimeValue = 100, scope = 1) => {
console.log('notifyEvent sendNotifyEvent', eventName, attributes, lifetimeValue, scope);
  if (window.nv) {
    console.log('notifyEvent Sending event to Notify:', eventName, attributes, lifetimeValue, scope);
    window.nv(
      'event',
      eventName,
      attributes,
      lifetimeValue,
      scope
    );
  }
};

export const notifyAppAccountOpenLp = (attributes, lifetimeValue = 100, scope = 1) => {
  sendNotifyEvent('App_account_open_lp', attributes, lifetimeValue, scope);
};

export const notifyAppLeadSubmit = (attributes, lifetimeValue = 100, scope = 1) => {
    console.log('notifyEvent notifyAppLeadSubmit', attributes, lifetimeValue, scope);
  sendNotifyEvent('App_lead_submit', attributes, lifetimeValue, scope);
};

export const notifyEmailSubmit = (attributes, lifetimeValue = 100, scope = 1) => {
  sendNotifyEvent('email_submitted_sa', attributes, lifetimeValue, scope);
};

export const notifyAppEmailVerified = (attributes, lifetimeValue = 100, scope = 1) => {
  sendNotifyEvent('App_email_submit', attributes, lifetimeValue, scope);
};

export const notifyAppPanSubmit = (attributes, lifetimeValue = 100, scope = 1) => {
  sendNotifyEvent('App_pan_submit', attributes, lifetimeValue, scope);
};

export const notifyMobileOtpSubmit = (attributes, lifetimeValue = 100, scope = 1) => {
  sendNotifyEvent('lead_verified_sa', attributes, lifetimeValue, scope);
};


const filterUserAttributes = (attributes) => {
    return Object.fromEntries(
        Object.entries(attributes).filter(([_, value]) => value !== undefined && value !== null && value !== '')
    );
};
// Function to set user info
export const notifySetUser = (userId, userAttributes) => {
    let filteredAttributes = filterUserAttributes(userAttributes);
  if (window.nv) {
    console.log('notifyEvent Setting user info in Notify');
    window.nv(
      'user',
      userId,
      filteredAttributes
    );
  }
};